import { Stack } from "@mui/material";
import React from "react";
const NoDataAvailable = (props: any) => {
	const { title, subTitle } = props;

	return (
		<Stack
            justifyContent={'center'}
            alignItems={'center'}
            gap={1}
            height={'100%'}
		>
			<img style={{ width: "200px", height: "200px" }} src="images/logo/no-wallpaper.png" />
			<span style={{ marginTop: "12px" }} className="text-787878-24px">
				{title}
			</span>
			<span style={{ marginTop: "10px" }} className="text-787878-16px">
				{subTitle}
			</span>
		</Stack>
	);
};
export default NoDataAvailable;
